/** Hard cap on entries per lorebook, enforced by the backend. */
export const MAX_LOREBOOK_ENTRIES = 5000;
/**
 * Derive what a server-paginated entries list should render, shared by both platforms so the two
 * cannot drift on which of the (loading / empty / error / load-more) states wins.
 *
 * `totalEntriesProp` is the backend's num_entries: on a paginated list the loaded rows are only one
 * page, so the count and the entry limit must come from metadata, not from what is on screen.
 */
export function computeEntriesViewState({ entryCount, totalEntriesProp, searchValue, hasMore, isLoadingFirstPage, isLoadingMore, hasError, }) {
    const totalEntries = totalEntriesProp ?? entryCount;
    const isSearchActive = Boolean(searchValue.trim());
    // A failed append keeps hasMore true (the cursor is retained), so it's a load-more error whose retry
    // pages again. A failed refresh clears hasMore while the list stays visible, so it's a refresh error
    // whose retry must re-run the refresh (onRetry), not pagination.
    const isLoadMoreErrorVisible = hasError && entryCount > 0 && !isLoadingMore && hasMore;
    return {
        totalEntries,
        hasReachedEntryLimit: totalEntries >= MAX_LOREBOOK_ENTRIES,
        isSearchActive,
        shouldShowEmptyState: entryCount === 0 && !isLoadingFirstPage,
        isLoadMoreErrorVisible,
        isRefreshErrorVisible: hasError && entryCount > 0 && !isLoadingMore && !hasMore,
        // Search results are never paginated (useLorebookEntries.loadNextPage bails out while a search is
        // active), yet a search response can still leave hasMore true when its final entry carries the
        // is_last_id cursor flag. Gate on !isSearchActive so the control never appears as a dead button.
        shouldShowLoadMore: hasMore && !isLoadingMore && !isLoadMoreErrorVisible && !isSearchActive,
        shouldShowSkeleton: isLoadingFirstPage && entryCount === 0,
    };
}
